import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get_user_details } from '../../redux/actions/userAuthActions'
import ModalComponent from '../../components/ModalComponent'
import Loader from '../../components/Loader'

import facebook_square from '../../assets/facebook_square.png'
import instagram_square from '../../assets/instagram_square.png'

import user_img from '../../assets/avatar-4.png'
import ww from '../../assets/ww.png'
import project_detail from '../../assets/project_detail.png'
import { GET_USER_DETAILS_RESET } from '../../redux/types'

const DashboardSingleUser = () => {
	const params = useParams()
	const dispatch = useDispatch()

	const getUserDetails = useSelector((state) => state.getUserDetails)
	const { loading, userDetails } = getUserDetails

	const [open, setOpen] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const displayHandler = (e) => {
		e.preventDefault()
		setOpen(!open)
	}

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	useEffect(() => {
		dispatch(get_user_details(params.slug))

		return () => {
			dispatch({ type: GET_USER_DETAILS_RESET })
		}
	}, [dispatch, params.slug])

	return (
		<main className='prof_det_page' style={{ padding: '2rem' }}>
			<section style={{ background: `url(${ww})` }}>
				{loading ? (
					<Loader />
				) : userDetails ? (
					<div className='container'>
						<div className='row'>
							<div className='col-md-5 col-sm-12'>
								<div className='prof_det_page_box'>
									<div className='text-center'>
										<img
											src={
												userDetails.profileImage
													? userDetails.profileImage
													: user_img
											}
											className='user_img'
											alt=''
											style={{ objectFit: 'cover', objectPosition: 'top' }}
										/>
									</div>
									<h4>
										{userDetails.firstName} {userDetails.lastName}
									</h4>
									<a
										href='#'
										onClick={displayHandler}
										className={
											!open
												? 'form-control btn prof_det_page_box_btn'
												: 'form-control btn prof_det_page_box_btn1'
										}
									>
										{!open ? (
											'Contact me'
										) : (
											<span> {userDetails.phoneNumber} </span>
										)}
									</a>

									<hr />

									<div className='d-flex justify-content-between'>
										<p>
											<img
												className='icon'
												src={require('../../assets/map_marker.png')}
												alt=''
											/>
											Location
										</p>
										<p>
											{userDetails.state}, {userDetails.country}.
										</p>
									</div>

									<div className='d-flex justify-content-between'>
										<p>
											<img
												className='icon'
												src={require('../../assets/user_icon.png')}
												alt=''
											/>
											Member since
										</p>
										<p> {new Date(userDetails.createdAt).getFullYear()}. </p>
									</div>

									<hr />

									<p>
										<strong>Description</strong>
									</p>
									<p> {userDetails.description} </p>

									<hr />

									<p>
										<strong>Languages</strong>
									</p>
									<p>{userDetails.language}</p>

									<hr />

									{/* <p>
										<strong>Linked Account</strong>
									</p>

									<a href={`${user_profile.fb_link}`} className='social'>
										<img src={facebook_square} alt='' />
										Facebook
									</a>
									<a href={`${user_profile.ig_link}`} className='social'>
										<img src={instagram_square} alt='' />
										Instagram
									</a>
									
									<hr /> */}

									<p>
										<strong>Skills</strong>
									</p>
									{/* <p>
										{userDetails.skills.map((e) => (
											<span className='mr-1 skill'> {e} </span>
										))}
									</p> */}
								</div>
							</div>
							<div className='col-md-7 col-sm-12'>
								<h3 className='section_header pt-2'>
									{userDetails.firstName}'s Projects
								</h3>
								<div className='row'>
									{/* {projects.map((e) => (
										<div className='col-md-6 prof_det_page_proj'>
											<a
												href='#'
												onClick={(e) => {
													e.preventDefault()
													setOpenModal(true)
												}}
											>
												<img src={e} alt='' style={{ objectFit: 'cover' }} />
											</a>
										</div>
									))} */}
									<p> No projects yet. </p>
								</div>
							</div>
						</div>
					</div>
				) : (
					<span> Nothing to display </span>
				)}
			</section>
			<ModalComponent
				open={openModal}
				toggle={toggleModal}
				size='lg'
				title='About Project'
			>
				<p style={{ fontSize: '14px' }}>
					It is a long established fact that a reader will be distracted by the
					readable content of a page when looking at its layout. The point of
					using Lorem Ipsum is that it has a more-or-less normal distribution of
					letters, as opposed to using 'Content here, content here', making it
					look like readable English.
				</p>

				<p>
					{' '}
					<strong>Link to project</strong>{' '}
				</p>
				<hr />
				<a href='#' target='_blank'>
					https//www.fullafricanvibes.com/blackproject/scopeone
				</a>
				<hr />
				<div className='mb-2 mt-2'>
					<img src={project_detail} className='img-fluid' alt='' />
				</div>
			</ModalComponent>
		</main>
	)
}

export default DashboardSingleUser
